import styled from "styled-components/macro";
import { Link, useLocation } from "react-router-dom";
import AuthorNation from "./AuthorNation";
import { AUTHOR_NATION } from "../../../../src/shared/conferenceCampaign";

const StyledContainer = styled.div`
  text-align: center;
  width: 100%;
  margin-bottom: 3em;

  .inner {
    width: 50%;
    height: 50%;
    margin: 25px auto 0 auto;
    text-align: center;
    padding: 3em;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;

    p {
      margin-bottom: 25px;
      line-height: 20px;
    }

    p.trouble {
      margin-top: 25px;
      font-size: 12px;
    }

    p.error {
      color: red;
      background: rgb(255, 202, 202);
      padding: 15px;
    }

    small {
      font-size: 12px;
    }

    h1 {
      text-align: center;
      font-family: "Lora";
    }

    input {
      margin-right: 15px;
    }

    input[type="text"] {
      font-size: 14px;
      padding: 5px;
    }

    label {
      margin-right: 15px;
    }

    .flash {
      background: darken($purple, 20%);
      color: white;
      width: 200px;
      margin: auto;
      padding: 10px;
      border-radius: 5px;
    }

    h1,
    h2,
    h3 {
      line-height: 1.3em;
    }

    .invite {
      h2 {
        margin-bottom: 15px;
      }

      p {
        line-height: 1.5em;
      }
    }
  }

  h1 {
    font-family: "GT Super Text";
    font-weight: 600;
    font-size: 54px;
    text-align: center;
    margin: 25px auto;
    line-height: 130%;
  }

  p {
    font-weight: 500;
    line-height: 130%;
    margin-bottom: 25px;
  }

  button {
    font-size: 16px;
    background: #4808d1;
    color: #fff;
    border: 0;
    border-radius: 10px;
    font-family: Inter;
    font-weight: 500;
    padding: 10px 40px;
    cursor: pointer;
    margin-top: 15px;
    box-shadow: var(--default-drop-shadow);
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 35px;
    }

    p {
      margin-bottom: 15px;
    }

    .inner {
      width: calc(100% - 4em);
      height: auto;
      margin: 0px auto 0 auto;
      text-align: center;
      padding: 2em;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 10px;
    }
  }
`;

const EventBonus = ({ openLogin, user }) => {
  const location = useLocation();
  if (new URLSearchParams(location.search).get("campaign") === AUTHOR_NATION.id) return <AuthorNation user={user} />;
  // const history = useHistory();
  // useEffect(() => {
  //   history.push("/a/20-books-vegas");
  // }, []);

  return (
    <StyledContainer>
      <div className="inner">
        <h1>Welcome 20Books Vegas Friends!</h1>

        <p>
          Thanks so much for stopping by the Sudowrite booth at 20Books Vegas! We hope we got a chance to chat and answer all of your questions, but just in case we didn’t&mdash;a brief refresher:
        </p>

        <p>
          Sudowrite is the AI writing partner of your dreams. Together with our powerful creative writing tools, our Story Bible feature is the fastest way to write a novel&mdash;taking you from start
          to finish in a week.
        </p>

        <p>
          We want you to try it for yourself, so we’re giving you <strong>15,000 AI words</strong> to get you started.
        </p>

        {!user && (
          <>
            <p>Claim them by setting up your free account here:</p>

            <Link to="/a/20-books-vegas">
              <button>Sign Up</button>
            </Link>
            <br />
            <br />
            <br />
            <br />
            <p>
              Already a Sudowrite user? Excellent! So cool to meet you out in Vegas. <br />
              Fill out <a href="https://airtable.com/appzYmPFcz9Wxzn0X/shrLxxB5xcl8Dguuh">this form</a> and we’ll send your bonus over ASAP.
            </p>
          </>
        )}

        {user && (
          <>
            <p>It looks like you're already logged into your Sudowrite account with email {user.email}</p>

            <p>
              Excellent! So cool to meet you out in Vegas. <br />
              Fill out <a href="https://airtable.com/appzYmPFcz9Wxzn0X/shrLxxB5xcl8Dguuh">this form</a> and we’ll send your bonus over ASAP.
            </p>

            <br />
            <br />

            <p>
              Not your account? <a href="/logout">Logout</a> and head back to this page
            </p>
          </>
        )}
      </div>
    </StyledContainer>
  );

  // const [redirected, setRedirected] = useState(false);

  // useEffect(() => {
  //   const cookies = new Cookies();

  //   const code = "20-books-vegas";

  //   // Set the invite code so that if user decides to use email sign they can generate a link directly with this code
  //   window.localStorage.setItem("inviteUrl", encodeURI(window.location.href + "#redirect"));
  //   cookies.set("affiliate", "20-books-vegas", {
  //     maxAge: 60 * 60 * 24 * 7,
  //     path: "/",
  //   });

  //   if (window.location.hash === "#redirect") {
  //     // we know they came back from signing in
  //     // give it a moment to wait to check
  //     setRedirected(true);
  //     window.location.hash = "";
  //   }
  // }, []);
  // TODO
  // Set up landing page, i.e. "Thanks for visiting us at 20Books!"
  // Banner with "Free words!"
  // Email signup form of some kind?
  // - we can just get email and assign words later
  // - we can have people actually sign up for an account (with the login component?)
  // - is there a way to assign words to pack quota for accounts that sign up via this component
  // - should we gate this in some way so it is only accessible via QR code/live events?
  //   - Generate QR code URL with a unique token (JWT?), i.e. www.sudowrite.com/event-bonus?token=UNIQUE_TOKEN
  //   - Check for token in component, either frontend or backend
  //   - If token exists, show component, allow signup, and assign 5k or 10k pack words to new user
  //   - If not, redirect user to `/` or `/app` depending on login status
  //   - Could also embed expiration data into the token so that it only works during the event (or immediately after)
  //   - this means checking for the expiration in the component, and would need to be modified for each event
  // return (
  //   <StyledContainer>

  //     <h1>Free words!</h1>
  //     <p>Thanks for visiting us at 20 Books Vegas!</p>

  //     <button onClick={openLogin}>Sign up!</button>
  //   </StyledContainer>
  // );
};

export default EventBonus;
